module.exports = __webpack_public_path__ + "media/npc_dota_hero_gyrocopter.77acb8d9.webm";